angular
    .module("skillBuilderSaaS")
    .filter("sbReplaceSingleQuote", function () {
    return function (text) {
        return text.replace(/'/g, "&#39;");
    };
});
